import React from 'react';
import Dropdown from "../../Dropdown";

import { Anchor, ChevronDown, CloudUpload, Mail, NoteAdd, UserSecret } from "../../../icons";
import Button from "../../Button";
import { HeaderLinksRoutes } from "../index";
import { createStyles } from "./styles";
import ToolsDropdownOption from "../ToolsDropdownOption";





var BaToolsDropdown = function BaToolsDropdown(_ref) {var customMainColor = _ref.customMainColor;
  var classes = createStyles({ customMainColor: customMainColor });

  var imCelticsOptions = [
  {
    value: HeaderLinksRoutes.UPLOAD_PRODUCTS,
    renderFunc: function renderFunc(key) {return /*#__PURE__*/(
        React.createElement(ToolsDropdownOption, {
          key: key,
          href: HeaderLinksRoutes.UPLOAD_PRODUCTS,
          icon: /*#__PURE__*/React.createElement(CloudUpload, null),
          linkText: "Upload Products",
          customMainColor: customMainColor }));}


  },
  {
    value: HeaderLinksRoutes.UPLOAD_SYNC_FILES,
    renderFunc: function renderFunc(key) {return /*#__PURE__*/(
        React.createElement(ToolsDropdownOption, {
          key: key,
          href: HeaderLinksRoutes.UPLOAD_SYNC_FILES,
          icon: /*#__PURE__*/React.createElement(NoteAdd, null),
          linkText: "Upload Sync Files",
          customMainColor: customMainColor }));}


  },
  {
    value: HeaderLinksRoutes.TRIGGER_RENEWALS,
    renderFunc: function renderFunc(key) {return /*#__PURE__*/(
        React.createElement(ToolsDropdownOption, {
          key: key,
          href: HeaderLinksRoutes.TRIGGER_RENEWALS,
          icon: /*#__PURE__*/React.createElement(Mail, null),
          linkText: "Trigger Renewals",
          customMainColor: customMainColor }));}


  },
  {
    value: HeaderLinksRoutes.PDF_VERIFIER,
    renderFunc: function renderFunc(key) {return /*#__PURE__*/(
        React.createElement(ToolsDropdownOption, {
          key: key,
          href: HeaderLinksRoutes.PDF_VERIFIER,
          icon: /*#__PURE__*/React.createElement(Anchor, null),
          linkText: "Pdf Verifier",
          customMainColor: customMainColor }));}


  }];


  var ToolsButton = /*#__PURE__*/
  React.createElement(Button, {
    type: "text",
    leftIconProp: /*#__PURE__*/React.createElement(UserSecret, null),
    rightIconProp: /*#__PURE__*/React.createElement(ChevronDown, null),
    size: "small",
    className: classes.dropdownButton }, "BA Tools");





  return /*#__PURE__*/(
    React.createElement(Dropdown, {
      name: "ba-tools",
      className: classes.toolDropdown,
      options: imCelticsOptions,
      openedElement: ToolsButton,
      closedElement: ToolsButton }));


};

export default BaToolsDropdown;
//# sourceMappingURL=index.js.map